import React from 'react';
import Modal from '../../../../components/modal/Modal';

export const DeleteForm = ({ deleteProps, deleteModalFormRef, deleteBtnLoader, setToggleDelete, handleOnSubmit }) => {
  return (
    <Modal {...deleteProps} className="sidebar__modal--center">
      <form
        name="delete"
        ref={deleteModalFormRef}
        onSubmit={(event) =>
          handleOnSubmit({
            event: event,
            name: 'delete',
            state: deleteProps
          })
        }
        className="ant-form ant-form-horizontal"
      >
        <h2 className="text-center mb-4">Da li sigurno želite da izbrišete odabranog korisnika ?</h2>

        <div className="form-group form-group-modal mb-4">
          {!deleteBtnLoader ? (
            <button data-cy="modal-delete-submit-btn" type="submit" className="btn btn-primary-link">
              <span className="text">Da</span>
            </button>
          ) : (
            <button type="button" className="btn btn-primary-outline">
              <span className="text">Brisanje...</span>
            </button>
          )}

          <button data-cy="modal-delete-cancel-btn" type="button" className="btn btn-primary" onClick={() => setToggleDelete(false)}>
            <span className="text">Ne</span>
          </button>
        </div>
      </form>
    </Modal>
  );
};
